<div class="d-flex" *ngIf="park">
  <div class="bg-dark text-light px-2 clickable" routerLink="/parks">
    <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
  </div>
  <div class="text-light bg-primary px-2 clickable" routerLink="/parks">
    <strong>{{park.name}}</strong>
  </div>
</div>
